export default __webpack_public_path__ + "assets/plus-component.c27169b5.svg";